// About.js
import React from 'react';
import { Typography, Box } from '@mui/material';
import AmityImage from '../amity.jpg';
import CoreyImage from '../corey.jpeg';
import ContactCard from './ContactCard';

const Contact = () => {

  const datax = {
    0: {
      'name': 'Amity Dolby',
      'title': 'Chairwoman, RLC of Virginia',
      'phone': '(804) 869-7501',
      'email': 'chair@rlcofva.org',
      'twitter': 'https://x.com/amitylee13',
      'image': AmityImage
    },
    1: {
      'name': 'Corey Fauconier',
      'title': 'Secretary, RLC of Virginia',
      'phone': '(973) 901-6481',
      'email': 'secretary@rlcofva.org',
      'twitter': 'https://x.com/CoreyMFauconier',
      'image': CoreyImage
    },
  }

  return (
    <div>
      <Typography variant="h5" gutterBottom>
        Contact
      </Typography>
      <Typography variant="body1">
        <Box
        sx={{
          display: 'flex',
          flexWrap: 'wrap',
          gap: '30px', // Space between cards
          justifyContent: 'center', // Align cards to the left
          // Responsive design for mobile
          '@media (max-width: 600px)': {
            flexDirection: 'column',
            alignItems: 'center', // Center cards on mobile
            gap: '8px', // Smaller gap for mobile
            padding: '8px', // Additional padding for mobile
          },
        }}
      >
        {Object.keys(datax).map((item, index) => (
          <ContactCard key={item} item={datax[item]} />
        ))}
      </Box>
      </Typography>
      <hr />
    </div>
  );
};

export default Contact;